/**
 * Categorias do catálogo (redesign admin, Fase 4). Puro e sem I/O.
 *
 * Não existe tabela de categorias: a categoria é um texto livre de
 * `operational.category` (vem do Bling). Esta visão AGRUPA os produtos por esse
 * texto — não cria, renomeia nem hierarquiza categoria (isso exigiria contrato
 * novo). Disponibilidade usa o mesmo cálculo das demais telas (reservas ativas
 * descontadas), nunca o estoque bruto.
 */
import type { PlatformCatalogProduct } from "../api/types.js";
import { availabilityOfProduct } from "./availability.js";

/** Rótulo do grupo de produtos sem categoria no Bling. */
export const UNCATEGORIZED_LABEL = "Sem categoria";

export interface CategorySummary {
  /** Valor exato de `operational.category`; `null` = sem categoria. */
  category: string | null;
  label: string;
  products: number;
  published: number;
  /** Soma da disponibilidade consolidada (estoque vendável − reservas ativas). */
  availableUnits: number;
  /** Produtos sem oferta vendável ou com disponibilidade crítica. */
  atRisk: number;
}

export function categorySummaries(products: PlatformCatalogProduct[]): CategorySummary[] {
  const groups = new Map<string | null, PlatformCatalogProduct[]>();
  for (const product of products) {
    const key = product.operational.category?.trim() || null;
    groups.set(key, [...(groups.get(key) ?? []), product]);
  }
  return [...groups.entries()]
    .map(([category, rows]) => {
      const availability = rows.map((product) => availabilityOfProduct(product));
      return {
        category,
        label: category ?? UNCATEGORIZED_LABEL,
        products: rows.length,
        published: rows.filter((product) => product.commercial.published).length,
        availableUnits: availability.reduce((sum, a) => sum + a.consolidated, 0),
        atRisk: availability.filter((a) => a.sellableStock === null || a.critical).length
      };
    })
    // Mais produtos primeiro; "Sem categoria" sempre por último (é pendência de cadastro).
    .sort((a, b) => (a.category === null ? 1 : b.category === null ? -1 : b.products - a.products || a.label.localeCompare(b.label, "pt-BR")));
}
